/* RoyalDTF custom language selector */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.royal-lang');
    if (!root) return;
    var trigger = root.querySelector('.royal-lang__trigger');
    var menu = root.querySelector('.royal-lang__menu');
    if (!trigger || !menu) return;

    var hoverCloseTimer = null;
    var isTouch =
      window.matchMedia && window.matchMedia('(hover: none)').matches;

    function open() {
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
      root.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      root.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      hoverCloseTimer = setTimeout(close, 180);
    }

    // Click trigger always toggles (works on desktop AND touch).
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.hasAttribute('data-open')) close();
      else open();
    });

    // Hover open on devices that can hover (desktops with mouse).
    if (!isTouch) {
      root.addEventListener('mouseenter', open);
      root.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('mouseenter', open);
    }

    // Click outside closes.
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    // Escape closes; keyboard navigation through options.
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        open();
        var first = menu.querySelector('a');
        if (first) first.focus();
      } else if (e.key === 'Escape') {
        close();
      }
    });

    menu.addEventListener('keydown', function (e) {
      var options = Array.prototype.slice.call(menu.querySelectorAll('a'));
      var idx = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (options[idx + 1] || options[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (options[idx - 1] || options[options.length - 1]).focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        options[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        options[options.length - 1].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        close();
        trigger.focus();
      }
    });

    // Cross-subdomain language switching with cart preservation and locale-aware URLs.
    //
    // 1) Resolve the localized URL of the current page for the destination locale.
    //    Shopify auto-generates <link rel="alternate" hreflang="<locale>" href="..."> tags
    //    that use the TRANSLATED handle on the destination subdomain. We read those so
    //    the user lands on the same product/collection/article in the new language —
    //    not on the English handle that 404s for translated content.
    //
    // 2) Cart preservation:
    //    - empty cart  → straight navigation to localized URL
    //    - 1 item      → /cart/add?id=X&quantity=N&return_to=<localized-path>
    //    - 2+ items    → /cart/v1:q1,v2:q2,...  (Shopify routes to checkout, cart preserved)
    function resolveLocalizedUrl(locale, fallbackUrl) {
      // Prefer Shopify's auto hreflangs (correct translated handles).
      // Multiple hreflangs may exist for the same locale (manual + auto + per-country variants).
      // Pick the LAST one matching <locale>, which is Shopify's auto-generated and most authoritative.
      var matches = document.querySelectorAll('link[rel="alternate"][hreflang="' + locale + '"]');
      if (matches.length > 0) {
        var last = matches[matches.length - 1];
        return last.getAttribute('href') || fallbackUrl;
      }
      return fallbackUrl;
    }

    menu.addEventListener('click', function (e) {
      var link = e.target.closest('a.royal-lang__option');
      if (!link) return;
      if (link.classList.contains('is-current')) return;
      e.preventDefault();

      var rawDest = link.getAttribute('href');
      var loc = link.getAttribute('data-locale') || link.getAttribute('hreflang');
      var localizedDest = resolveLocalizedUrl(loc, rawDest);

      var u;
      try { u = new URL(localizedDest); } catch (err) {
        // Fall back to homepage of destination subdomain if URL parsing fails.
        try { u = new URL(rawDest); } catch (e2) { window.location.href = rawDest; return; }
        localizedDest = u.origin + '/';
      }
      var destPath = u.pathname + (u.search || '');
      var returnTo = destPath || '/';

      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var items = (cart && cart.items) || [];

          if (items.length === 0) {
            window.location.href = localizedDest;
            return;
          }
          if (items.length === 1) {
            var only = items[0];
            window.location.href = u.origin + '/cart/add?id=' + encodeURIComponent(only.variant_id) +
              '&quantity=' + encodeURIComponent(only.quantity) +
              '&return_to=' + encodeURIComponent(returnTo);
            return;
          }
          // Multi-item cart — Shopify cart permalink (forwards to checkout, cart preserved).
          var pairs = items
            .map(function (i) { return i.variant_id + ':' + i.quantity; })
            .join(',');
          window.location.href = u.origin + '/cart/' + pairs;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
